import { EmptyContainer, EmptyImage, EmptyMessage, ThemedFabButton, ThemedListHeader } from 'common/styles';
import AccountList from 'common/components/AccountList';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import ContainerBase from 'common/containers/ContainerBase';
import LeftNav from 'common/components/LeftNav';
import { mapStateToProps } from 'reducers';
import { navigations } from 'features/settings/containers/SettingsContainer';
import Page from 'common/components/Page';
import React from 'react';
import SuccessSnackbar from 'common/components/SuccessSnackbar';
import { withTranslation } from 'react-i18next';
import { WizardLaunchSource } from 'features/wizard/WizardContextBuilder';

class AccountsContainer extends ContainerBase {
    constructor(props) {
        const {
            appState = props.appState || {},
            location = props.location || {},
            t
        } = props;

        let isSnackbarOpen = false;
        let snackbarMessage = '';
        if (location.state && location.state.accountDidUpdate) {
            isSnackbarOpen = true;
            snackbarMessage = 'settings.accounts.accountDetails.successMessage';
        } else if (location.state && location.state.unlinkAccountSuccess
        ) {
            isSnackbarOpen = true;
            snackbarMessage = 'settings.accounts.accountDetails.unlinkSuccess';
        }
        super(props, {
            accounts: appState.accountsSorted && appState.accountsSorted(t),
            isSnackbarOpen: isSnackbarOpen,
            snackbarMessage: snackbarMessage
        });
    }

    handleAdd = () => {
        const { history } = this.props;

        history.push('/wizard/link-account', { launchSource: WizardLaunchSource.SETTINGS_ADD_ACCOUNT });
    }

    handleAccountSelection = accountNumber => {
        const { history } = this.props;

        history.push('/settings/accounts/' + accountNumber);
    }

    handleSnackbarClose = () => {
        this.setState({ isSnackbarOpen: false });
    }

    render() {
        const { t } = this.props;

        const {
            accounts = this.state.accounts || [],
            isSnackbarOpen,
            snackbarMessage
        } = this.state;

        const hasAccountsToDisplay = accounts.length > 0;

        return (
            <Page>
                <LeftNav title="settings.header" to="/settings" navigations={navigations}>
                    <ThemedListHeader>
                        {t('settings.accounts.header')}
                    </ThemedListHeader>

                    <ThemedFabButton
                        size="small"
                        color="primary"
                        aria-label={t('settings.accounts.aria.addAccount')}
                        onClick={this.handleAdd}
                    >
                        <AddIcon />
                    </ThemedFabButton>

                    {hasAccountsToDisplay ? (
                        <AccountList accounts={accounts} onClickAccount={this.handleAccountSelection} t={t}/>
                    ) : (
                        <EmptyContainer>
                            <EmptyImage src="/img/empty_state_default.svg" />
                            <EmptyMessage>
                                {t('common.noAccountsLinkedMessage')}
                            </EmptyMessage>
                        </EmptyContainer>
                    )}
                    <SuccessSnackbar
                        id="snackbar"
                        open={isSnackbarOpen}
                        onClose={this.handleSnackbarClose}
                        message={t(snackbarMessage)}
                    />
                </LeftNav>
            </Page>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(AccountsContainer));
